import { Chip } from "@mui/material";
import ActionsCell from "./ActionsCell";
import StatusCell from "./StatusCell";
import MessageCell from "./MessageCell";

export const getColumns = (
  setSelectedNotification,
  setOpenDeleteNotification,
  setSelectedRow,
  setOpenSendNotificationModal,
  setOpenViewUsersModal,
  setSelectedNotificationForUsers
) => [
  {
    field: "sn",
    headerName: "SN",
    width: 50,
    sortable: false,
    filterable: false,
    renderCell: (params) => {
      const visibleSortedRows = params.api.getSortedRowIds?.();
      const index = visibleSortedRows?.indexOf(params.id);
      return index !== undefined ? index + 1 : "";
    },
  },
  {
    field: "message",
    headerName: "Message",
    width: 300,
    renderCell: (params) => <MessageCell message={params.value} />,
  },
  {
    field: "created_at",
    headerName: "Created Date",
    width: 180,
  },
  {
    field: "is_allow_custom_template",
    headerName: "Custom Template?",
    width: 150,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <Chip
        label={params.value === 1 ? "Yes" : "No"}
        color={params.value === 1 ? "success" : "default"}
        variant={params.value === 1 ? "filled" : "outlined"}
        size="small"
        sx={{ fontWeight: 500 }}
      />
    ),
  },
  {
    field: "is_sent",
    headerName: "Is Notified",
    width: 120,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <StatusCell
        params={params}
        setSelectedRow={setSelectedRow}
        setOpenSendNotificationModal={setOpenSendNotificationModal}
      />
    ),
  },
  {
    field: "sent_at",
    headerName: "Notified Date",
    width: 180,
  },
  {
    field: "total_notify_users",
    headerName: "Total Notified Users",
    width: 160,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "action",
    headerName: "Action",
    width: 350,
    sortable: false,
    renderCell: (params) => (
      <ActionsCell
        params={params}
        setSelectedNotification={setSelectedNotification}
        setOpenDeleteNotification={setOpenDeleteNotification}
        setOpenViewUsersModal={setOpenViewUsersModal}
        setSelectedNotificationForUsers={setSelectedNotificationForUsers}
      />
    ),
  },
];
